var _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcademeSectionBgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 1509,
    viewBox: "0 0 1920 1509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_79",
    "data-name": "Line 79",
    y1: 1509,
    transform: "translate(1666)",
    fill: "none",
    stroke: "#d6d6d6",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_80",
    "data-name": "Line 80",
    x1: 1920,
    transform: "translate(0 120)",
    fill: "none",
    stroke: "#d6d6d6",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_425",
    "data-name": "Line 425",
    x2: 1798,
    transform: "translate(0.5 1475.837)",
    fill: "none",
    stroke: "#d6d6d6",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademeSectionBgLines);
export default __webpack_public_path__ + "static/media/AcademeSectionBgLines.3640e3aea78ab7d8daea5191285b7989.svg";
export { ForwardRef as ReactComponent };